export const SESSION_DURATION = 24 * 60 * 60 * 1000; // 24 hours


export const getSession = () => {
  const session = localStorage.getItem("session");
  return session ? JSON.parse(session) : null;
};

export const isSessionValid = () => {
  const session = getSession();
  if (!session) return false;

  const now = Date.now();
  return now - session.loginTime < SESSION_DURATION;
};

export const logout = () => {
  localStorage.removeItem("session");
  window.location.href = "/"; // Redirect to login page
};
